<div class="pageheader">
  <div class="page-title">
    <h1>Mail Templates</h1>
    <div class="btn-group">
      <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
      <app-change-log-link *bizPermissionRequired="'Mail_Template_View_Log'" [title]="'Mail templates log'">
        <app-change-log-link-entity type="MailTemplate"></app-change-log-link-entity>
      </app-change-log-link>
    </div>
  </div>
</div>

<dx-data-grid #mailtemplates biz-grid
  [selection]='{ mode: "none" }'
  [dataSource]='mailTemplates()'
  [showBorders]="true"
  [bizSetColumnChooser]="true"
  [bizSetAllowColumnReordering]="false"
  [bizSetGroupPanel]="false"
  [bizSetPager]="false"
  [bizSetHeaderFilter]="true"
  [bizSetSummary]="false"
  [bizHideSelectedRowsCompnent]="true"
  [allowColumnResizing]="true"
  keyExpr="Id"
  (onRowDblClick)="onRowDblClick($event)"
  >

  <dxo-editing [allowAdding]="false" [allowUpdating]="allowUpdating" [allowDeleting]="false"></dxo-editing>

  <dxo-group-panel
    [visible]="true">
  </dxo-group-panel>


  <dxi-column width="20%" dataField="DisplayName" caption="Template Name" dataType="string" sortOrder="asc"></dxi-column>
  <dxi-column width="30%" dataField="Description" caption="Template Description" dataType="string"></dxi-column>

  <dxi-column width="35%"
    dataField="DefaultMailSubject"
    caption="Mail Subject"
    dataType="string"
    [calculateDisplayValue]="calculateSubjectDisplayValue">
  </dxi-column>

  <dxi-column
    width="15%"
    dataField="Using"
    caption="Using"
    dataType="string"
    [calculateDisplayValue]="calculateUsingDisplayValue">
  </dxi-column>

  <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="false"><dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(mailTemplates(), 'CreatedBy'))"></dxo-header-filter></dxi-column>
  <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>
  <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="false"><dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(mailTemplates(), 'UpdatedBy'))"></dxo-header-filter>   </dxi-column>
  <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="false" format="dateTime"></dxi-column>

  @if (allowUpdating) {
    <dxi-column type="buttons" [fixed]="true" fixedPosition="right">
      <dxi-button name="edit" text="Edit" [onClick]="onEditButtonClick"></dxi-button>
    </dxi-column>
  }

</dx-data-grid>

